import { apiClient } from "./client";

export type PosterStatus = 0 | 1 | 2; // 0=active, 1=takenDown, 2=vandalized

export interface PosterFeatureProperties {
    id: string;
    quantity: number;
    status: PosterStatus;
    placedByMe: boolean;
    placedAt: string;
}

export interface PostersGeoJson {
    type: "FeatureCollection";
    features: Array<{
        type: "Feature";
        id: string;
        geometry: { type: "Point"; coordinates: [number, number] };
        properties: PosterFeatureProperties;
    }>;
    metadata: { totalCount: number };
}

export interface PosterStatistics {
    myTodayCount: number;
    teamTodayCount: number;
    teamTotalCount: number;
}

export interface PlacePosterRequest {
    campaignId: string;
    latitude: number;
    longitude: number;
    quantity: number;
}

export const fetchPostersGeoJson = async (
    campaignId: string,
    bbox?: string,
    signal?: AbortSignal
): Promise<PostersGeoJson> => {
    const response = await apiClient.get<PostersGeoJson>("/map/posters", {
        params: { campaignId, bbox },
        signal
    });
    return response.data;
};

export const placePoster = async (request: PlacePosterRequest): Promise<{ id: string }> => {
    const response = await apiClient.post<{ id: string }>("/posters", request);
    return response.data;
};

export const deletePoster = async (posterId: string): Promise<void> => {
    await apiClient.delete(`/posters/${posterId}`);
};

export const updatePosterStatus = async (posterId: string, status: PosterStatus): Promise<void> => {
    await apiClient.patch(`/posters/${posterId}/status`, { status });
};

export const getPosterStatistics = async (campaignId: string): Promise<PosterStatistics> => {
    const response = await apiClient.get<PosterStatistics>("/posters/statistics", {
        params: { campaignId }
    });
    return response.data;
};
